import dayjs from '../../../../utils/dayjsConfig'
import { buildUserReportPdf } from './routeExecutionPdfBuilder'
import { buildTimestampControlKpis, buildTimestampControlRows } from '../timestampControlExportData'

export const buildTimestampControlPdf = ({
  results = [],
  timestampSummary = {},
  isTimestampSameDay,
  startDate,
  endDate,
  ...header
}) => {
  const rows = buildTimestampControlRows(results)
  return buildUserReportPdf({
    ...header,
    title: 'Control de horario',
    tableTitle: 'VISITAS · CONTROL DE HORARIO',
    period: `${dayjs(startDate).format('DD/MM/YYYY')} - ${dayjs(endDate).format('DD/MM/YYYY')}`,
    generatedAt: dayjs().format('DD/MM/YYYY hh:mm A'),
    kpis: [],
    totals: buildTimestampControlKpis(timestampSummary, isTimestampSameDay),
    headers: [
      'Fecha',
      'Cliente',
      'Hora de inicio',
      'Hora de finalización',
      'Duración de visita',
      'Dentro de geocerca',
      'Ubicación'
    ],
    rows: rows.map((row) => [
      row.date,
      row.client,
      row.start,
      row.end,
      row.duration,
      row.geofence,
      row.startUrl || row.endUrl ? 'Ver mapa' : '-'
    ]),
    columnStyles: {
      0: { cellWidth: 75 },
      1: { cellWidth: 220 },
      2: { cellWidth: 90, halign: 'center' },
      3: { cellWidth: 100, halign: 'center' },
      4: { cellWidth: 90, halign: 'center' },
      5: { cellWidth: 95 },
      6: { cellWidth: 66, halign: 'center' }
    },
    chipColumns: [5],
    onDrawCell: ({ cell, row, column, section }, pdf) => {
      if (section !== 'body' || column.index !== 6) return
      const visit = rows[row.index]
      const url = visit?.startUrl || visit?.endUrl
      if (url) pdf.link(cell.x, cell.y, cell.width, cell.height, { url })
    }
  })
}
